// extracted by mini-css-extract-plugin
export var burger = "navigation-module--burger--c5d6d";
export var container = "navigation-module--container--ccc9e";
export var containerMobile = "navigation-module--containerMobile--53b29";
export var contentHeight = "navigation-module--contentHeight--de418";
export var dropdown = "navigation-module--dropdown--59125";
export var dropdownLi = "navigation-module--dropdownLi--3e4ab";
export var flex = "navigation-module--flex--901c4";
export var header = "navigation-module--header--e802d";
export var link = "navigation-module--link--a23a7";
export var linkButton = "navigation-module--linkButton--b21f0";
export var menuItem = "navigation-module--menuItem--e1fba";
export var menuItemContent = "navigation-module--menuItemContent--c238f";
export var mobileMenu = "navigation-module--mobileMenu--eaab7";
export var mobileMenuOpen = "navigation-module--mobileMenuOpen--9e459";
export var open = "navigation-module--open--78888";
export var page = "navigation-module--page--f5795";
export var pages = "navigation-module--pages--10f8c";
export var subItemIcon = "navigation-module--subItemIcon--7f7fa";
export var subItemMobile = "navigation-module--subItemMobile--1faa4";
export var subMenu = "navigation-module--subMenu--c32d4";
export var subMenuButton = "navigation-module--subMenuButton--e1a75";
export var subMenuOpen = "navigation-module--subMenuOpen--a09b6";